import styled from 'styled-components';

export const CancelSessionWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: -50px;
`;
